module.exports = __webpack_public_path__ + "5acc3a0fff0ce031b253d6685e96d83e.pdf";